import React, { useEffect } from 'react';
import { Row, Col, Form, Button, Flex, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';

import { TypePerfil } from '@/Models/Pessoa/Perfil';
import { useBuscarPerfil } from '@/Services/Sistema/PerfilService';

type PerfilFormBasicProps = {
    codigo?: number;
    apenasLeitura?: boolean;
    aoCancelar?: () => void;
    aoFinalizar?: (perfil: TypePerfil) => void;

    txtBtnSalvar?: string;
    txtBtnCancelar?: string;
    btnSalvarLoading?: boolean;

    esconderAcoes?: boolean;
    habilitarTutoriais?: boolean;
};

const IDs = {
    formDadosBasicos: "formulario-dados-basicos-perfil",
}

export const PerfilFormBasic: React.FC<PerfilFormBasicProps> = (props) => {
    const txtBtnSalvar = props.txtBtnSalvar ?? "Salvar";
    const txtBtnCancelar = props.txtBtnCancelar ?? "Cancelar";

    interface Formulario extends TypePerfil {}

    const [form] = useForm<Formulario>();

    const estaEditando = props.codigo != undefined;
    const {perfil: perfilEncontrado, query} = useBuscarPerfil(props.codigo ?? 0, estaEditando);

    useEffect(() => {
        if(perfilEncontrado == null) return;

        form.setFieldsValue(perfilEncontrado);
    }, [perfilEncontrado])

    const onFinish = () => {
        form.validateFields()
            .then((v) => {
                const payload: TypePerfil = {
                    ...v,
                    codigo: props.codigo
                };

                props.aoFinalizar?.(payload);
            });
    };

    return (
        <React.Fragment>
            <Row gutter={[16, 16]}>

                <Col xs={24}>
                    <Form<Formulario> disabled={props.apenasLeitura} layout="vertical" autoComplete="off" form={form} id={IDs.formDadosBasicos}>
                        <Row gutter={16}>
                            <Col xs={24} md={24} style={{ marginTop: 15 }}>
                                <Form.Item<Formulario> name={"nome"} rules={[{ required: true, message: "Por favor, informe um nome!" }]}
                                    label={"Nome"} style={{ margin: 0 }}>
                                    <Input placeholder='Nome'/>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Col>

                {!props.esconderAcoes && (
                    <Col span={24}>
                        <Flex align="center" justify="center" gap={16}>
                            {props.aoCancelar && (
                                <Button
                                    danger
                                    type="primary"
                                    key={"cancel"}
                                    onClick={() => {
                                        props.aoCancelar && props.aoCancelar();
                                    }}
                                >
                                    {txtBtnCancelar}
                                </Button>
                            )}
                            {!props.apenasLeitura && props.aoFinalizar && (
                                <Button loading={props.btnSalvarLoading} type="primary" onClick={onFinish}>
                                    {txtBtnSalvar}
                                </Button>
                            )}
                        </Flex>
                    </Col>
                )}
            </Row>
        </React.Fragment>
    );
}